<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { PmsiTypeEnum } from '@/store/modules/settings/types'

const { t } = useI18n()

defineProps<{
  pmsiType: PmsiTypeEnum
}>()
</script>

<template>
  <div class="maintenance-home container">
    <div class="card">
      <div class="card-body">
        <h1 class="mb-4">
          {{ t('maintenance.title') }}
        </h1>
        <div
          class="row text-center"
        >
          <div
            class="col-6 p-3"
          >
            <router-link
              class="border d-block p-3"
              :to="{name: 'maintenance-event-observer', params: {pmsiType}}"
            >
              {{ t('maintenance.eventObserver.title') }}
            </router-link>
          </div>
          <div
            class="col-6 p-3"
          >
            <router-link
              class="border d-block p-3"
              :to="{name: 'maintenance-stay-history', params: {pmsiType}}"
            >
              {{ t('maintenance.stayHistory.title') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
}
</style>